module.exports = __webpack_public_path__ + "img/icon3.145435cd.png";